import { render, staticRenderFns } from "./Three2.vue?vue&type=template&id=20766aec&scoped=true&"
import script from "./Three2.vue?vue&type=script&lang=js&"
export * from "./Three2.vue?vue&type=script&lang=js&"
import style0 from "./Three2.vue?vue&type=style&index=0&id=20766aec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20766aec",
  null
  
)

export default component.exports